import axios from 'axios';
import React, { useEffect } from 'react'
import { Link } from "react-router-dom";

//this is 404 page
export default function NotFound() {
  const [errorMessage, setErrorMessage] = React.useState("");
  const apiMain = "https://bbyshin-backend.onrender.com/api"; // Main API configuration

  useEffect(() => {
    fetchNotFound();
  }, []);

  const fetchNotFound = async () => {
    try {
      const response = await axios.get(`${apiMain}/not-found`); // Adjust the URL as needed
      if (response.status === 404) {
        console.error("Page not found");
        setErrorMessage("Page not found");
        return { error: "Page not found" };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching page:", error);
      setErrorMessage("An error occurred");
      return { error: "An error occurred" };
    }
  };

  return (
    <div className='w-screen h-screen flex justify-center items-center flex-col'>
      <h1 className='text-8xl'>404</h1>
      {errorMessage && <p className='text-red-500 text-xl'>{errorMessage}</p>}
      <Link to="/">
        <span className='text-xl text-blue-300'>Back to main page</span>
      </Link>
    </div>
  );
}
